
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import stores from "@/stores";
import { SweetModal } from "sweet-modal-vue";
import { hasModulePermissionForType } from "@/helpers/permissions";
import { translate, titleCase } from '@/helpers/functions';
import { showToaster } from '@/components/DashboardComposer/helpers';
import moment from 'moment';

@Component({
    methods: {
        hasModulePermissionForType,
        titleCase, translate
    },
    components: {
        SweetModal,
    },
})
export default class EditCleaningRequest extends Vue {
    @Prop()
    item: any;

    skipRequest: ISkipCleaningRequest = this.getInitialOrderState();
    showConfirmation: boolean = false;

    getInitialOrderState(): ISkipCleaningRequest {
        let locationObj = {
            id: 0,
            propertyId:null,
            name: '',
            description: '',
            pmsRoomId: '',
            staff: false,
            active: true,
            sort: null,
            crmRoomId: '',
            createdAt: '',
            updatedAt: '',
            translatables: [],
            categories: [],
        }
        let customerObj = {
            id: null,
            erpId: null,
            isCompany: false,
            company: '',
            shortDescription: '',
            gender: '',
            documentType: '',
            salutation: '',
            firstName: '',
            lastName: '',
            nationality: '',
            dateOfBirth: '',
            placeOfBirth: '',
            identityNumber: '',
            taxNumber: '',
            active: true,
            accounts: [],
            addresses: [],
            contacts: [],
            image: '',
            imageId: null,
            neighbours: '',
            languages: '',
            documents: [],
        }
        return {
            id: 0,
            customerId: 0,
            date: '',
            location: locationObj,
            status: '',
            createdAt: '',
            updatedAt: '',
            customer: customerObj,
            customerContact: '',
        };
    }

    @Watch('item', { immediate: true })
    onItemChanged() {
        if (this.item !== null) {
            this.skipRequest = { ...this.item };
        }
    }

    changeAction() {
        if (this.item.status !== 'CONFIRMED' && this.skipRequest.status === 'CONFIRMED') {
            this.showConfirmation = true;
        } else if (this.item.status !== 'CANCELED' && this.skipRequest.status === 'CANCELED') {
            this.showConfirmation = true;
        } else if (this.item.status !== 'PENDING' && this.skipRequest.status === 'PENDING') {
            this.showConfirmation = true;
        } 
        else {
            this.save();
        }
    }

    get guestName() {
        if (this.skipRequest.customer) {
            let firstName = translate(this.skipRequest.customer.firstName);
            let lastName = translate(this.skipRequest.customer.lastName);
            if (firstName !== '' || lastName !== '') {
                return `${firstName} ${lastName}`;
            }
            return `${translate(firstName)} ${translate(lastName)}`;
        } else {
            return '';
        }
    }

    get customerEmail() {
        if (this.skipRequest.customerContact !== undefined) {
            return this.skipRequest.customerContact.value
        }

        return '';
    }

    get roomType (){
        if(this.skipRequest.location?.categories.length > 0){
            return this.skipRequest.location.categories[0].name
        }
        return '';
    }

    get locationName(){
        return this.skipRequest.location?.name
    }

    formatDate(date: string | null) {
        return date ? moment(date).format('DD.MM.YYYY HH:mm') : '';
    }

    formatSkinOnDate(date: string | null){
        return date ? moment(date).format('DD.MM.YYYY') : '';
    }

    cancel() {
        // @ts-ignore
        this.$children[0].close();
    }

    getTranslatedModuleName(moduleName: string) {
        const translatedName = translate(moduleName);
        return translatedName && translatedName !== '' ? translatedName : moduleName;
    }

    save() {
        const requestBody = {
            status: this.skipRequest.status,
            skipCleaningId: this.skipRequest.id
        };
        stores.SkipCleaning.updateStatus(requestBody)
            .then((response) => {
                if (response.responseCode) {
                    showToaster('success', translate('success'),translate('successfully-updated'));
                    this.showConfirmation = false;
                    this.cancel();
                } else if (response.responseCode == 404) {
                    showToaster('danger','',translate('unable-to-update'),400)
                    this.cancel();
                } else {
                    // showToaster('danger', '', response.error.message);
                }
            });
    }

    getClassesOfSelectedStatus(status:string) {
        let classes = '';
        switch (status) {
            case 'CANCELED':
                return 'bg-grey text-color-grey font-weight-bold px-3 py-1';
            case 'CONFIRMED':
                return 'bg-yellow text-color-yellow font-weight-bold px-3 py-1';
            case 'PENDING':
                return 'bg-orange text-color-orange font-weight-bold px-3 py-1';
        }
        return classes;
    }
}

